// extracted by mini-css-extract-plugin
module.exports = {"error":"ErrorMessage_error__1H5R8","fade_in":"ErrorMessage_fade_in__3osOU"};